import * as React from 'react'
import styled from 'styled-components'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import Web3 from 'web3'
import { useState, useEffect } from 'react'
import { Avatar, Button, CircularProgress, Typography } from '@mui/material'
import moment from 'moment'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import './singleTransaction.css'
import { useNavigate } from 'react-router-dom'
import './Blocks.css'

export default function Blocks() {
  const web3 = new Web3()

  web3.setProvider('https://rpc.Dexit.network')
  const navigate = useNavigate()
  const [dd, setdd] = useState([])
  const [showDetails, setShowDetails] = useState(false)
  const [callFunction, setCallFunction] = useState(true)

  useEffect(() => {
    Init()
  }, [])

  async function Init() {
    try {
      let bc = []

      let currentBlock = await web3.eth.getBlockNumber()
      setCallFunction(!callFunction)
      for (let j = currentBlock - 5; j <= currentBlock; j++) {
        let getBlockDetails = await web3.eth.getBlock(j)
        bc.push(getBlockDetails)
      }
      setdd([...dd, ...bc])
    } catch (error) {
      console.log(error)
    }
  }

  const singleTransactionDetails = (row) => {
    setShowDetails(true)
    navigate('/singledetails', { state: { row: row } })
  }

  const handleChangeState = () => {
    setShowDetails(false)
  }

  const shortenAccountId = (fullStr) => {
    const strLen = 20
    const separator = '...'

    if (fullStr?.length <= strLen) return fullStr

    const sepLen = separator.length
    const charsToShow = strLen - sepLen
    const frontChars = Math.ceil(charsToShow / 3)
    const backChars = Math.floor(charsToShow / 3)

    return (
      fullStr?.substr(0, frontChars) +
      separator +
      fullStr?.substr(fullStr?.length - backChars)
    )
  }

  const handleViewAllBlocks = () => {
    navigate('/allblocks')
  }

  return (
    <>
      {!showDetails ? (
        <div>
          {/* <h1>Block Details</h1> */}
          {/* <Input
          type="number"
          placeholder="Search block"
          onChange={(e) => setSearchBlock(e.target.value)}
        />
        <Button
          variant="outlined"
          onClick={searchTransactionByBlock}
          sx={{ ml: 2 }}
        >
          Search
        </Button> */}
          <TableContainer
            component={Paper}
            sx={{
              padding: '1rem',
              width: 'initial',
              borderRadius: '20px',
              color: '#FFFFF9',
              backgroundColor: '#2C2E3F',
            }}
          >
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <Typography sx={{ padding: 1 }}>Latest Blocks</Typography>
                </TableRow>
                {/* <TableRow style={{ background: 'whitesmoke' }}> */}
                {/* <TableCell align="left">Number</TableCell> */}
                {/* <TableCell align="left">Hash</TableCell> */}
                {/* <TableCell align="center">Transactions</TableCell> */}
                {/* <TableCell align="left">Timestamp</TableCell> */}
                {/* </TableRow> */}
              </TableHead>
              {dd.length > 0 ? (
                <TableBody
                  sx={{
                    height: '500px !important',
                    overflowY: 'auto',
                    display: 'block',
                  }}
                >
                  {dd
                    .slice(0)
                    .reverse()
                    .map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          cursor: 'pointer',
                          padding: 1,
                        }}
                        onClick={() => singleTransactionDetails(row)}
                      >
                        <TableRow>
                          <TableCell sx={{ width: '8rem' }}></TableCell>
                          <TableCell sx={{ width: '20rem' }}></TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>Block</TableCell>
                          <TableCell>{row.number}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>Age</TableCell>
                          <TableCell>
                            {moment
                              .unix(row.timestamp)
                              .format('YYYY-MM-DD h:mm:ss a')}
                          </TableCell>
                        </TableRow>
                        {/* <TableRow>
                          <TableCell>Hash</TableCell>
                          <TableCell>{shortenAccountId(row.hash)}</TableCell>
                        </TableRow> */}
                        <TableRow>
                          <TableCell>Txns</TableCell>
                          <TableCell>{row.transactions.length}</TableCell>
                        </TableRow>
                        <TableRow
                          sx={{
                            '& td, & th': {
                              borderBottom: '1px solid #8997b1 !important',
                            },
                          }}
                        >
                          <TableCell></TableCell>
                          <TableCell></TableCell>
                        </TableRow>
                      </TableRow>
                    ))}
                </TableBody>
              ) : (
                <TableBody
                  sx={{
                    height: '500px !important',
                    overflowY: 'auto',
                    display: 'block',
                  }}
                >
                  <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <CircularProgress />
                  </Box>
                </TableBody>
              )}
            </Table>
            <Button
              className="blocksBtn"
              variant="contained"
              color="grey"
              fullWidth
              onClick={handleViewAllBlocks}
              size="large"
            >
              View All Blocks
            </Button>
          </TableContainer>
        </div>
      ) : (
        <div className="single_block">
          <ArrowBackIcon
            onClick={handleChangeState}
            fontSize="large"
            sx={{ mt: 3 }}
          />
        </div>
      )}
    </>
  )
}
